<template>
  <div>
    <div class="container">
      <h1
        class="font-weight-bolder"
        style="font-size: 22px; font-weight: 700; color: #000000"
      >
        Form Pendaftaran
      </h1>
      <h4 class="mb-6 text-dark font-weight-normal">
        Pilih kelas sesuai target karirmu
      </h4>
      <div
        class="card"
        :class="
          is_card_program_show == false || is_next_page == true ? 'd-none' : ''
        "
      >
        <div class="card-body">
          <CardProgram @selectCourse="selectCourse" :form="form" :routePushGeneral="routePushGeneral" :routePushRegister="routePushRegister"> </CardProgram>
        </div>
      </div>

      <!-- Register -->
      <div class="row my-4">
        <div
          class="col-12 col-md-3"
          v-if="is_card_program_show == false || is_next_page == true"
        >
          <div class="card">
            <div class="ct-card-image">
              <img :src="program.product_image" alt="" />
            </div>

            <div class="card-bottom d-flex flex-column">
              <div>
                <h5 class="title">{{ program.name }}</h5>
                <!-- <p class="desc">
                        {{
                          program.description.length > 42
                            ? program.description.substring(0, 42) + "..."
                            : program.description
                        }}
                      </p> -->
                <div class="d-flex align-items-end">
                  <div class="svg-wrapper mr-2 mt-2">
                    <svg
                      aria-hidden="true"
                      class="e-font-icon-svg e-far-calendar-alt"
                      viewBox="0 0 448 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                      ></path>
                    </svg>
                  </div>
                  <div>
                    <span
                      class=""
                      style="color: #52525b; font-size: 13px; font-weight: 500"
                      >{{ program.info_period }}</span
                    >
                  </div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="svg-wrapper mr-2 mt-2">
                    <svg
                      aria-hidden="true"
                      class="e-font-icon-svg e-far-clock"
                      viewBox="0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
                      ></path>
                    </svg>
                  </div>
                  <div>
                    <span
                      class=""
                      style="color: #52525b; font-size: 13px; font-weight: 500"
                      >{{ program.info_schedule }}</span
                    >
                  </div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="svg-wrapper mr-2 mt-2">
                    <svg
                      aria-hidden="true"
                      class="e-font-icon-svg e-fas-chalkboard-teacher"
                      viewBox="0 0 640 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
                      ></path>
                    </svg>
                  </div>
                  <div>
                    <span
                      class=""
                      style="color: #52525b; font-size: 13px; font-weight: 500"
                      >{{ program.info_session }}</span
                    >
                  </div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="svg-wrapper mr-2 mt-2">
                    <svg
                      aria-hidden="true"
                      class="e-font-icon-svg e-fas-graduation-cap"
                      viewBox="0 0 640 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
                      ></path>
                    </svg>
                  </div>
                  <div>
                    <span
                      class=""
                      style="color: #52525b; font-size: 13px; font-weight: 500"
                      >{{ program.info_certificate }}</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="font-weight-bolder d-flex justify-content-between align-items-center mt-5"
                style="font-size: 14px"
              >
                <span class="font-weight-bolder"></span>
                <span
                  class="font-weight-bolder text-danger"
                  style="color: #52525b"
                >
                  <strike v-if="program.course_type_id == 1"
                    >Rp. 7.000.000</strike
                  >
                  <strike v-if="program.course_type_id == 2"
                    >Rp. 2.000.000</strike
                  >
                </span>
              </div>
              <div class="">
                <div
                  v-for="(price, i) in program.course_prices"
                  :key="i"
                  class="font-weight-bold d-flex justify-content-between"
                  style="font-size: 16px"
                >
                  <span>{{ price.name }}</span>
                  <span class="font-weight-bolder">
                    Rp {{ formatPrice(program.course_prices[i].price) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <b-button
            variant="default"
            block
            class="text-dark mt-1"
            @click="goBack"
          >
            <i class="fas fa-arrow-left text-dark"></i> Kembali
          </b-button>
        </div>
        <div class="col-12 col-md-9">
          <div class="card" v-if="is_program_selected">
            <div class="card-body">
              <div class="row g-5 align-items-start justify-content-center">
                <div class="col-12">
                  <div class="form-section" v-if="is_biodata_form_show">
                    <b-form-group
                      label="Email:"
                      label-for="input-email"
                      label-class="my-label"
                    >
                      <b-form-input
                        id="input-email"
                        v-model="form.email"
                        class="form-control my-form"
                        placeholder="Masukkan Email Kamu"
                        @input="checkEmail"
                      ></b-form-input>
                      <small class="text-danger">{{ error.email }}</small>
                    </b-form-group>

                    <b-form-group
                      label="Nama:"
                      label-for="input-name"
                      label-class="my-label"
                    >
                      <b-form-input
                        id="input-name"
                        v-model="form.name"
                        class="form-control my-form"
                        placeholder="Masukkan Nama Kamu"
                        :disabled="
                          is_use_old_email == true
                            ? true
                            : !is_email_valid
                            ? true
                            : false
                        "
                      ></b-form-input>
                      <small class="text-danger">{{ error.name }}</small>
                    </b-form-group>

                    <b-form-group
                      label="No. Whatsapp:"
                      label-for="input-phone"
                      label-class="my-label"
                    >
                      <b-form-input
                        id="input-phone"
                        v-model="form.phone"
                        class="form-control my-form"
                        placeholder="08xxxxxxxxxxxx"
                        :disabled="
                          is_use_old_email == true
                            ? true
                            : !is_email_valid
                            ? true
                            : false
                        "
                      ></b-form-input>
                      <small class="text-danger">{{ error.phone }}</small>
                    </b-form-group>

                    <!-- <b-button class="register-back-btn" @click="goBack">
                      Kembali
                    </b-button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mt-3" v-if="form.course_type_id == 1">
        <div class="card-body">
          <template>
            <b-form-group
              label="Jenis:"
              label-for="input-course_price_id"
              v-if="form.course_type_id == 1"
              label-class="my-label"
            >
              <b-form-select
                v-model="form.course_price_id"
                :options="course_prices"
                class="form-control my-form my-select"
                id="input-course_price_id"
                @input="inputPriceId"
                placeholder="Pilih Jenis"
                :disabled="!is_email_valid ? true : false"
              ></b-form-select>
              <small class="text-danger">{{ error.course_price_id }}</small>
            </b-form-group>

            <b-form-group>
              <label for="input-agency_name" class="my-label">{{
                priceType == 1
                  ? "Nama Universitas/Sekolah:"
                  : "Nama Instansi/Perusahaan:"
              }}</label>
              <b-form-input
                id="input-agency_name"
                v-model="form.agency_name"
                :placeholder="
                  priceType == 1
                    ? 'Masukkan Nama Universitas/Sekolah'
                    : 'Masukkan Nama Instansi/Perusahaan'
                "
                class="form-control my-form"
                :disabled="!is_email_valid ? true : false"
              ></b-form-input>
              <small class="text-danger">{{ error.agency_name }}</small>
            </b-form-group>

            <template v-if="priceType">
              <div class="row mb-6">
                <div class="col-12 col-md-4">
                  <div class="photo-wrapper">
                    <img
                      class="image"
                      :src="[
                        uploadedImageUrl == ''
                          ? form.attachment
                          : uploadedImageUrl,
                      ]"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <b-form-group id="input-group-image">
                    <label for="input-image"
                      >Lampirkan bukti pendukung (KTM/Kartu Pelajar):
                    </label>
                    <b-form-file
                      v-model="form.attachment"
                      placeholder="Upload Gambar"
                      drop-placeholder="Drop file here..."
                      @change="onFileUpload"
                    ></b-form-file>
                    <small class="text-danger">{{ error.photo }}</small>
                  </b-form-group>
                  <p class="text-danger">
                    <span class="ml-2"
                      >Kartu mahasiswa akan diverifikasi setelah
                      pembayaran.</span
                    >
                    <br />
                    ❗Jika tidak valid, akun akan dibatalkan tanpa pengembalian
                    dana.
                  </p>
                </div>
              </div>
            </template>

            <b-form-checkbox
              v-model="form.is_pay_later"
              name="check-button"
              switch
              :disabled="!is_email_valid ? true : false"
            >
              Bayar nanti saja ?
              <b>({{ form.is_pay_later ? "Ya" : "Tidak" }})</b>
            </b-form-checkbox>
            <p v-if="form.is_pay_later == 1" class="mt-3">
              Transfer ke BNI 1859830073 a.n. PT Wellmagic Media Digital.
              Konfirmasi ke admin setelah transfer untuk aktivasi akunmu.
            </p>
          </template>

          <b-form-checkbox
            class="mb-5 mt-8"
            id="checkbox-1"
            v-model="form.is_agree"
            name="checkbox-1"
            value="1"
            unchecked-value="0"
            v-if="form.is_pay_later == 1"
            ><span class="text-body-2-medium"
              >Saya Menyetujui
              <a href="#">Ketentuan Layanan,</a>
              Serta
              <a href="#">Kebijakan Privasi</a>
              Digiskill</span
            >
          </b-form-checkbox>
          <b-button
            v-b-toggle.collapse-2
            size="sm"
            class="m-1 py-3 px-8 mt-5 ct-button"
            @click="form.is_agree == 1 ? premiumRegister() : showAlert()"
            v-if="form.is_pay_later == 1"
            :disabled="
              form.is_agree == 1 && is_email_valid == true ? false : true
            "
          >
            Daftar
          </b-button>
        </div>
      </div>

      <div
        class="card mt-3"
        v-if="
          form.is_pay_later == 0 &&
          is_program_selected &&
          program.course_type_id == 1
        "
      >
        <div class="card-body">
          <b-form-group
            label="Jenis Pembayaran:"
            label-for="input-course_price_id"
            label-class="my-label"
          >
            <b-form-select
              v-model="form.course_installment_id"
              :options="course_installments"
              class="form-control my-form my-select"
              id="input-course_installment_id"
              @input="inputInstallmentId"
              placeholder="Pilih Jenis Pembayaran"
              :disabled="!is_email_valid ? true : false"
            ></b-form-select>
            <small class="text-danger">{{ error.course_installment_id }}</small>
          </b-form-group>

          <div class="row" v-if="form.is_installment == 1">
            <div class="col-12">
              <h6>Rincian Pembayaran :</h6>
              <div class="table-responsive">
                <table class="table table-bordered" style="font-size: 16px">
                  <thead>
                    <tr>
                      <th>Nama</th>
                      <th width="6%">Total Angsuran</th>
                      <th>Angsuran Ke -</th>
                      <th>Jumlah Cicilan</th>
                      <th>Harga Program</th>
                      <th>DP</th>
                      <th>Keterangan</th>

                      <!-- <th>Nominal DP</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(installment, i) in installments" :key="i">
                      <template v-if="i == 0">
                        <td :rowspan="installments.length">
                          {{ installment.name }}
                        </td>
                      </template>
                      <template v-if="i == 0">
                        <td :rowspan="installments.length">
                          {{ installment.total }}
                        </td>
                      </template>
                      <td>{{ `Angsuran ke- ${i + 1}` }}</td>
                      <td>
                        <span class="text-danger font-weight-bolder"
                          >Rp. {{ formatPrice(installment.amount) }}</span
                        >
                      </td>
                      <template v-if="i == 0">
                        <td :rowspan="installments.length">
                          <span>Rp. {{ formatPrice(course_price.price) }}</span>
                        </td>
                      </template>
                      <template v-if="i == 0">
                        <td :rowspan="installments.length">
                          Rp. {{ formatPrice(installment.dp_amount) }} + (PPN
                          {{ ppn }}%)
                          <span class="d-block font-weight-bolder"
                            >Rp. {{ getTotalDp() }}</span
                          >
                        </td>
                      </template>
                      <template v-if="i == 0">
                        <td :rowspan="installments.length">
                          <p>💳 Skema Pembayaran:</p>
                          <span
                            >Cicilan 1 (50%) – Saat daftar & sebelum kelas
                            dimulai</span
                          >
                          <br />
                          <span
                            >Cicilan 2 (50%) – Minggu ke-3 kelas berjalan</span
                          >
                          <p class="mt-5">📌 Catatan Penting:</p>
                          <span
                            >Akses kelas dibuka setelah cicilan pertama
                            lunas</span
                          >
                          <br />
                          <span
                            >Keterlambatan >7 hari = akses ditangguhkan</span
                          >
                          <br />
                          <span
                            >Sertifikat diberikan setelah cicilan lunas
                          </span>
                          <br />
                          <span>Pembayaran tidak dapat dikembalikan </span>

                          <p class="mt-5">
                            🔐 Info rekening akan dikirim setelah pendaftaran
                            dikonfirmasi.
                          </p>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="card mt-3"
        v-if="form.is_pay_later == 0 && is_program_selected"
      >
        <div class="card-body">
          <label for="input-amount" class="my-label"
            >Kode Promo (Opsional):
          </label>
          <div class="input-group">
            <b-form-input
              id="input-amount"
              v-model="form.promo_code"
              placeholder="Masukkan Kode Promo yang Kamu Miliki"
              class="form-control-custom my-form col-12 col-md-3"
              autocomplete="off"
              :disabled="!is_email_valid ? true : false"
            ></b-form-input>
            <div class="input-group-append">
              <b-button @click="checkPromo" class="text-white ct-button"
                >Cek</b-button
              >
            </div>
          </div>
        </div>
      </div>

      <!-- checkout -->
      <div
        class="row mt-3"
        v-if="form.is_pay_later == 0 && is_program_selected"
      >
        <div class="col-12 col-md-8">
          <div class="card">
            <div class="card-body">
              <h5
                class="mb-4 font-weight-bold text-black"
                style="font-size: 18px"
              >
                Metode Pembayaran
              </h5>

              <div class="row g-4">
                <div
                  class="col-6 col-md-4 col-lg-3 mb-3"
                  v-for="(payment, i) in payment_method"
                  :key="i"
                >
                  <div
                    class="payment-tile position-relative p-3 rounded-3 border"
                    :class="{ selected: payment.id === form.payment_method_id }"
                    @click="choosePaymentMethod(payment)"
                  >
                    <div class="image-wrapper mb-3">
                      <img
                        :src="payment.url_image"
                        :alt="payment.payment_method_name"
                        class="img-fluid"
                        style="max-height: 50px"
                      />
                    </div>
                    <div class="font-weight-bold text-dark text-center">
                      {{ payment.payment_method_name }}
                    </div>

                    <!-- checkmark when selected -->
                    <div
                      v-if="payment.id === form.payment_method_id"
                      class="checkmark-icon position-absolute top-0 end-0 m-2"
                    >
                      <i class="bi bi-check-circle-fill text-success fs-5"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="card">
            <div class="card-body">
              <!-- Program -->
              <div class="mb-3">
                <span class="text-summary text-black font-weight-bolder"
                  >Program</span
                >
                <div class="d-flex justify-content-between align-items-center">
                  <span class="fw-bold text-summary-detail">{{
                    program.name
                  }}</span>
                  <div>
                    <span
                      class="fw-bold text-summary-detail text-dark"
                      style="white-space: nowrap"
                      >Rp
                      {{
                        formatPrice(course_price.price) == 0
                          ? "-"
                          : formatPrice(course_price.price)
                      }}</span
                    >
                    <div
                      class="fw-bold text-summary-detail text-dark"
                      v-if="form.is_installment == 1"
                    >
                      <span class="font-weight-bolder">(DP)</span> Rp
                      {{ getTotalDp() }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Pajak -->
              <hr />
              <div class="mb-3">
                <span class="text-summary text-black font-weight-bolder"
                  >Pajak</span
                >
                <div class="d-flex justify-content-between align-items-center">
                  <span class="fw-bold text-summary-detail"
                    >PPN ({{ ppn }}%)</span
                  >
                  <span class="fw-bold text-summary-detail"
                    >Rp
                    {{
                      totalPpn
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".") == 0
                        ? "-"
                        : totalPpn
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                    }}</span
                  >
                </div>
              </div>

              <!-- Lainnya -->
              <hr />
              <div class="mb-3">
                <span class="text-summary text-black font-weight-bolder"
                  >Lainnya</span
                >
                <div class="d-flex justify-content-between align-items-center">
                  <span class="fw-bold text-summary-detail">Biaya Layanan</span>
                  <span class="fw-bold text-summary-detail"
                    >Rp
                    {{
                      extra.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") ==
                      0
                        ? "-"
                        : extra.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                    }}</span
                  >
                </div>
              </div>

              <!-- Diskon -->
              <template v-if="discount">
                <hr />
                <div class="mb-3">
                  <span class="text-summary text-black font-weight-bolder"
                    >Diskon</span
                  >
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span class="fw-bold text-summary-detail">{{
                      discount.name
                    }}</span>
                    <span class="fw-bold text-summary-detail text-danger">
                      <template v-if="!discount.is_percent">
                        - Rp {{ discount.amount_show }}
                      </template>
                      <template v-else>
                        - {{ discount.amount_show }}%
                      </template>
                    </span>
                  </div>
                </div>
              </template>

              <!-- Total -->
              <hr />
              <div
                class="d-flex justify-content-between align-items-center bg-light p-2 rounded mt-3"
              >
                <span class="text-summary text-black font-weight-bolder"
                  >TOTAL</span
                >
                <span
                  class="text-summary-detail text-black font-weight-bolder"
                  style="white-space: nowrap"
                  v-if="form.is_installment == 0"
                  >Rp {{ getTotal() == 0 ? "-" : getTotal() }}</span
                >
                <span
                  class="text-summary-detail text-black font-weight-bolder"
                  style="white-space: nowrap"
                  v-if="form.is_installment == 1"
                  >Rp {{ getTotalWithDp() }}</span
                >
              </div>

              <!-- Metode Pembayaran -->
              <div
                class="d-flex justify-content-between align-items-center mt-3"
              >
                <span class="text-summary">Metode Pembayaran</span>
                <span class="text-summary">
                  {{ form.payment_bank ? form.payment_bank : "-" }}
                </span>
              </div>
            </div>
          </div>
          <b-form-checkbox
            class="mb-5 mt-8"
            id="checkbox-1"
            v-model="form.is_agree"
            name="checkbox-1"
            value="1"
            unchecked-value="0"
            ><span class="text-body-2-medium"
              >Saya Menyetujui
              <a href="#">Ketentuan Layanan,</a>
              Serta
              <a href="#">Kebijakan Privasi</a>
              Digiskill</span
            >
          </b-form-checkbox>
          <div class="col-12 mt-2 d-flex justify-content-center">
            <b-button
              class="text-center d-flex my-btn ct-button justify-content-center btn-block font-weight-bolder font-size-20 py-3"
              :disabled="form.is_agree == 1 && is_email_valid ? false : true"
              @click="form.is_agree == 1 ? formOnSubmit() : showAlert()"
            >
              Daftar
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modalLogin"
      size="md"
      title=""
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="p-4">
        <template v-if="!is_use_old_email">
          <h3 class="mb-3 text-center">
            Oops! Email Kamu Sudah Terdaftar di Digiskill Hub.
          </h3>
          <b-button
            size="sm"
            class="mt-5 btn ct-button"
            @click="is_use_old_email = true"
            block
          >
            Login dengan akun lama
          </b-button>
          <b-button size="sm" @click="useAnotherEmail" block>
            Gunakan email lain untuk buat akun baru.
          </b-button>
        </template>
        <template v-else>
          <div class="form-group">
            <div class="d-flex justify-content-between mt-n5">
              <label class="font-weight-bold text-dark">Email</label>
            </div>
            <input
              type="text"
              class="form-control login-form"
              placeholder="Email"
              v-model="form.email"
            />
          </div>
          <div class="form-group">
            <div class="d-flex justify-content-between mt-n5">
              <label class="font-weight-bold text-dark">Password</label>
            </div>
            <div id="example-input-group-2">
              <div class="input-group mb-2">
                <input
                  class="form-control-login form-control login-form h-auto py-3 px-6"
                  :type="passwordIsVisible"
                  name="password"
                  ref="password"
                  v-model="form.password"
                  autocomplete="off"
                />
                <div
                  class="input-group-prepend"
                  @click="
                    passwordIsVisible == 'password'
                      ? (passwordIsVisible = 'text')
                      : (passwordIsVisible = 'password')
                  "
                >
                  <div
                    class="input-group-text"
                    style="border: none; cursor: pointer"
                  >
                    <template v-if="passwordIsVisible == 'password'">
                      <b-icon-eye-slash></b-icon-eye-slash>
                    </template>
                    <template v-if="passwordIsVisible == 'text'">
                      <b-icon-eye></b-icon-eye>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button size="sm" class="btn ct-button" @click="onSubmitLogin">
              Login
            </b-button>
            <b-button
              size="sm"
              variant="secondary"
              class="ml-2"
              @click="useAnotherEmail"
            >
              Batal
            </b-button>
          </div>
        </template>
      </div>
    </b-modal>
  </div>
</template>


<script>
import { debounce } from "@/core/modules/Helper.js";
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import { setRegistrant } from "@/core/services/jwt.service.js";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { getRegistrant, setBilling } from "@/core/services/jwt.service.js";
import CardProgram from "@/view/pages/class/CardProgram.vue";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import ApiService from "@/core/services/api.service.js";
import JwtService from "@/core/services/jwt.service";

export default {
  components: { CardProgram },
  props: {
    routePushGeneral: {
      type: String,
      default: "/class/payment",
    },
    routePushRegister: {
      type: String,
      default: "/class/register",
    },
    current_user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      passwordIsVisible: "password",
      form: {
        payment_method_id: "",
        payment_method: "",
        payment_bank: "",
        name: "",
        email: "",
        phone: "",
        course_price_id: "",
        agency_name: "",
        course_type_id: "",
        course_key_name: "",
        course_installment_id: "",
        is_installment: 0,
        is_pay_later: 0,
        is_agree: 0,
      },
      error: {
        name: "",
        email: "",
        phone: "",
        course_installment_id: "",
        course_price_id: "",
        agency_name: "",
        is_pay_later: "",
        is_installment: "",
      },
      program: {
        description: "",
      },
      isLoaded: false,
      course_prices: [],
      priceType: false,
      uploadedImageUrl: "",

      course_price: {
        price: 0,
      },
      payment_method: [],
      registrant: getRegistrant(),
      extra: 0,
      ppn: 0,
      total: 0,
      discount: null,
      totalPpn: 0,
      course_installments: [],
      installments: [],
      installment_selected: {},
      is_program_selected: false,
      is_biodata_form_show: true,
      is_card_program_show: true,
      is_next_page: false,
      is_email_valid: false,
      is_use_old_email: false,
    };
  },
  methods: {
    checkEmail() {
      // if (this.form.course_type_id != 3) {
      //   debounce(() => {
      //     this.getEmail();
      //   }, 500);
      // } else {
      //   this.is_email_valid = true;
      // }
      debounce(() => {
        this.getEmail();
      }, 500);
    },
    useAnotherEmail() {
      this.is_email_valid = false;
      this.is_use_old_email = false;
      this.form.email = "";
      this.$bvModal.hide("modalLogin");
    },
    async getEmail() {
      let response = await module.getFullResponse(
        `api/check-email?email=${this.form.email}`
      );
      if (response == null) {
        this.is_email_valid = true;
      } else {
        this.is_email_valid = false;
        this.$bvModal.show("modalLogin");
      }
    },
    onSubmitLogin() {
      SwalLoading.fire();

      var email = this.form.email;
      var password = this.form.password;

      this.$store.dispatch(LOGOUT);

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(LOGIN, { email, password })
          // go to which page after successfully login
          .then((resp) => {
            // console.log("berhasil login sdsdsd", resp);
            if (resp.hasOwnProperty("status_code") && resp.status_code == 500) {
              SwalLoading.close();
              Swal.fire({
                title: "Login Gagal",
                text: "Email atau Password Salah",
                icon: "error",
                confirmButtonClass: "btn btn-secondary",
                heightAuto: false,
              });
              // return;
              console.log("stop");
              console.log("baru");
              throw new Error("Login Fail");
            }
            let access_right, role_right;
            ApiService.get("api/users/me").then((data) => {
              // //("user/me", data)
              ApiService.put(`api/users/${data.data.data.id}/set-user-on`)
                .then((response) => {
                  //('success set login')
                })
                .catch((error) => {
                  //('error set login')
                });
              ApiService.get("api/users/" + data.data.data.id).then(
                (response) => {
                  if (data.data.data) {
                    ApiService.get("api/roles/" + data.data.data.role_id).then(
                      (result) => {
                        access_right = response.data.meta.access_right_display;
                        role_right = result.data.meta.access_right_display;

                        let merge = [...access_right, ...role_right];

                        window.localStorage.setItem(
                          "access_right_display",
                          JSON.stringify(merge)
                        );

                        let user = data.data.data;
                        JwtService.setUser(JSON.stringify(user));

                        // this.$router.push({ name: "dashboard" });
                        SwalLoading.close();

                        this.setAfterLogin(response.data.data);
                      }
                    );
                  } else if (!data.data.data.position_id) {
                    window.localStorage.setItem(
                      "access_right",
                      response.data.meta.access_right
                    );

                    window.localStorage.setItem(
                      "access_right_display",
                      JSON.stringify(response.data.meta.access_right_display)
                    );

                    let user = data.data.data;
                    access_right = response.data.meta.access_right;
                    user.access_right = response.data.meta.access_right;
                    JwtService.setUser(JSON.stringify(user));

                    for (let z = 0; z < 20; z++) {
                      if (z == 19) {
                        // this.$router.push({ name: "dashboard" });
                        this.setAfterLogin(response.data.data);
                        SwalLoading.close();
                      }
                    }
                  }
                }
              );
            });
          })
          .catch(() => {});
      }, 100);
    },
    setAfterLogin(data) {
      Swal.fire({
        title: "Berhasil",
        text: "Kamu berhasil login",
        icon: "success",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      this.form.email = data.email;
      this.form.name = data.name;
      this.form.phone = data.phone;
      this.is_email_valid = true;
      this.$bvModal.hide("modalLogin");
    },
    showAlert() {
      Swal.fire({
        title:
          "Anda belum menyetujui ketentuan layanan serta kebijakan privasi",
        text: "Silahkan centang persetujuan",
        icon: "error",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    },
    goBack() {
      this.$route.query.course = "";
      this.is_next_page = false;
      // this.$router.go(-1);
      this.$router.push("/class/register");
      this.is_card_program_show = true;
      this.is_biodata_form_show = true;
      this.is_program_selected = false;

      // payment_method_id: "",
      //   payment_method: "",
      //   payment_bank: "",
      //   name: "",
      //   email: "",
      //   phone: "",
      //   course_price_id: "",
      //   agency_name: "",
      //   course_type_id: "",
      //   course_key_name: "",
      //   course_installment_id: "",
      //   is_installment: 0,
      //   is_pay_later: 0,

      this.form.payment_method_id = "";
      this.form.payment_method = "";
      this.form.payment_bank = "";
      this.form.name = "";
      this.form.email = "";
      this.form.phone = "";
      this.form.course_price_id = "";
      this.form.agency_name = "";
      this.form.course_type_id = "";
      this.form.course_key_name = "";
      this.form.course_installment_id = "";
      this.form.is_installment = 0;
      this.form.is_pay_later = 0;
      this.course_installments = [];
      this.installments = [];
      this.installment_selected = {};
      this.course_price.price = 0;
      this.priceType = false;
    },
    inputInstallmentId(evt) {
      console.log("inputInstallmentId", evt);
      if (evt == null) {
        this.form.is_installment = 0;
        console.log("this.form", this.form);
        this.installments = [];
      } else {
        let findInstallment = this.course_installments.find(
          (installment) => installment.value == evt
        );
        this.form.is_installment = 1;
        this.form.course_installment_id = findInstallment.value;
        this.installment_selected = findInstallment;

        // let total = this.getTotal();
        // this.installments = [];
        // for (let i = 0; i < findInstallment.total; i++) {
        //   this.installments.push({
        //     name: findInstallment.text,
        //     dp_amount: findInstallment.dp_amount,
        //     total: findInstallment.total,
        //     amount: findInstallment.amount,
        //   });
        // }
        this.setInstallment();
      }
    },
    setInstallment() {
      let price = this.course_price.price;
      let discount_amount = 0;
      let totalPpn = (price * this.ppn) / 100;
      if (this.discount != null) {
        if (this.discount.is_percent) {
          discount_amount = (price * this.discount.amount) / 100;
        } else {
          discount_amount = this.discount.amount;
        }
      }
      let discount = discount_amount;
      let price_final = price - discount + totalPpn;

      let price_final_after_dp =
        price_final - this.installment_selected.dp_amount;

      let installment_amount =
        price_final_after_dp / this.installment_selected.total;

      this.form.is_installment = 1;
      this.form.course_installment_id = this.installment_selected.value;

      // let total = this.getTotal();
      this.installments = [];
      for (let i = 0; i < this.installment_selected.total; i++) {
        this.installments.push({
          name: this.installment_selected.text,
          dp_amount: this.installment_selected.dp_amount,
          total: this.installment_selected.total,
          amount: Math.ceil(installment_amount),
        });
      }
    },
    async getCourseInstallment() {
      let response = await module.getFullResponse(
        `api/course-installment-list?course_price_id=${this.form.course_price_id}`
      );
      // If Data Not Found
      if (response == null) {
        // Redirect To List
      } else {
        this.course_installments = response.data.data.map((item) => {
          return {
            value: item.id,
            text: `${item.name}`,
            course_id: `${item.course_id}`,
            total: `${item.total}`,
            dp_amount: `${item.dp_amount}`,
            amount: `${item.amount}`,
            is_installment: 1,
          };
        });
        this.course_installments.unshift({
          value: null,
          text: "Pembayaran Penuh",
          is_installment: 0,
        });
        this.course_installments.unshift({
          value: "",
          text: "Pilih Jenis Pembayaran",
          disabled: true,
        });
      }
    },
    getTotalDp() {
      let totalPpn = (this.course_price.price * this.ppn) / 100;
      return this.formatPrice(
        parseInt(this.installment_selected.dp_amount) + parseInt(totalPpn)
      );
    },
    getTotalWithDp() {
      let totalPpn = (this.course_price.price * this.ppn) / 100;
      let dpFinal =
        parseInt(this.installment_selected.dp_amount) + parseInt(totalPpn);
      return this.formatPrice(parseInt(dpFinal) + parseInt(this.extra));
    },
    async checkPromo() {
      let response = await module.getFullResponse(
        `api/promos-check?promo_code=${this.form.promo_code}`
      );
      // If Data Not Found
      if (response == null) {
        // Redirect To List
      } else {
        let discount = response.data.data;
        if (
          discount.is_percent == 0 &&
          discount.amount > this.course_price.price
        ) {
          Swal.fire({
            title: "Promo tidak berlaku",
            text: "Jumlah diskon melebihi harga program",
            icon: "error",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.discount = null;
          return;
        }

        console.log("discount", discount);
        if (
          discount.is_quantity_limit == 1 &&
          discount.max_quantity == discount.current_quantity
        ) {
          Swal.fire({
            title: "Promo sudah tidak berlaku",
            text: "Kuota promo sudah habis",
            icon: "error",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          return;
        } else {
          Swal.fire({
            title: "Berhasi",
            text: "Berhasil menerapkan promo",
            icon: "success",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
        this.discount = response.data.data;
        if (this.form.is_installment == 1) {
          this.setInstallment();
        }
      }
    },
    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(price);
    },
    onFileUpload(evt) {
      this.uploadedImageUrl = URL.createObjectURL(evt.target.files[0]);
      this.form.attachment = evt.target.files[0];
    },
    selectCourse(course, is_next_page = null) {
      this.program = course;
      this.form.course_id = course.id;
      this.form.course_type_id = course.course_type_id;
      this.is_program_selected = true;

      if (is_next_page != null) this.is_next_page = is_next_page;

      this.getCoursePrice(course.key_name);
    },
    inputPriceId(event) {
      let course_price = this.course_prices.find((item) => item.value == event);
      if (course_price.type == 1) {
        this.priceType = true;
      } else {
        this.priceType = false;
      }

      this.course_price = course_price;
      this.discount = null;
      this.form.promo_code = "";
      // this.getDiscount();
      this.getCourseInstallment();
      this.getPaymentOption();
    },
    async getCoursePrice(key_name) {
      let response = await module.getFullResponse(
        `api/course-price-by-key/${key_name}?is_active=1`
      );
      // If Data Not Found
      if (response == null) {
        // Redirect To List
      } else {
        if (this.form.course_type_id == 1) {
          this.course_prices = response.data.data.map((item) => {
            return {
              value: item.id,
              text: `${item.name}`,
              type: item.type,
              price: item.price,
              course_id: item.course_id,
              id: item.id,
              name: item.name,
            };
          });
        } else {
          this.course_price = response.data.data[0];
          this.form.course_price_id = response.data.data[0].id;
        }
      }
    },

    async getPaymentMethod() {
      let response = await module.getFullResponse(
        `api/xendit-payment-methods?page=1&page_size=40`
      );
      // If Data Not Found
      if (response == null) {
        // Redirect To List
      } else {
        this.payment_method = response.data.data;
        this.payment_method.forEach((element) => {
          if (element.payment_method_name == "BCA") {
            element.order = 1;
          } else if (element.payment_method_name == "BRI") {
            element.order = 2;
          } else if (element.payment_method_name == "BNI") {
            element.order = 3;
          } else if (element.payment_method_name == "Mandiri") {
            element.order = 4;
          } else if (element.payment_method_name == "Permata Bank") {
            element.order = 7;
          } else if (element.payment_method_name == "Alfamart") {
            element.order = 5;
          } else if (element.payment_method_name == "DANA") {
            element.order = 6;
          } else if (element.payment_method_name == "GOPAY") {
            element.order = 8;
          } else if (element.payment_method_name == "LinkAja") {
            element.order = 9;
          } else if (element.payment_method_name == "OVO") {
            element.order = 10;
          } else if (element.payment_method_name == "ShopeePay") {
            element.order = 11;
          } else if (element.payment_method_name == "QRIS") {
            element.order = 12;
          }
        });

        this.payment_method.sort((a, b) => a.order - b.order);
      }
    },
    async getDiscount() {
      let response = await module.getFullResponse(`api/promos-active`);
      // If Data Not Found
      if (response == null) {
        // Redirect To List
      } else {
        this.discount = response.data.data;
      }
    },
    async getPaymentOption() {
      let response = await module.getFullResponse(`api/payment-options`);
      // If Data Not Found
      if (response == null) {
        // Redirect To List
      } else {
        this.ppn = response.data.ppn;
        this.extra = response.data.surcharge;
      }
    },
    choosePaymentMethod(data) {
      this.form.payment_method_id = data.id;
      this.form.payment_method = data.category;
      this.form.payment_bank = data.payment_method_name;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getTotal() {
      let price = this.course_price.price;
      let extra = this.extra;
      let ppn = this.ppn;
      let discount;

      let totalPpn = (price * ppn) / 100;
      if (this.discount == null) {
        discount = 0;
      } else {
        if (this.discount.is_percent) {
          discount = (price * this.discount.amount) / 100;
        } else {
          discount = this.discount.amount;
        }
      }

      this.totalPpn = totalPpn;
      let total =
        (Number(price) || 0) +
        (Number(extra) || 0) +
        (Number(totalPpn) || 0) -
        (Number(discount) || 0);
      return this.formatPrice(total);
    },
    validation() {
      let valid = true;
      if (this.form.name == "") {
        this.error.name = "Nama tidak boleh kosong";
        valid = false;
      } else {
        this.error.name = "";
      }
      if (this.form.email == "") {
        this.error.email = "Email tidak boleh kosong";
        valid = false;
      } else {
        this.error.email = "";
      }
      if (this.form.phone == "") {
        this.error.phone = "No. HP tidak boleh kosong";
        valid = false;
      } else {
        this.error.phone = "";
      }
      // if (this.form.course_price_id == "") {
      //   this.error.course_price_id = "Pilih Jenis tidak boleh kosong";
      //   valid = false;
      // } else {
      //   this.error.course_price_id = "";
      // }
      // if (this.form.agency_name == "") {
      //   this.error.agency_name =
      //     "Nama Instansi / Perusahaan tidak boleh kosong";
      //   valid = false;
      // } else {
      //   this.error.agency_name = "";
      // }

      return valid;
    },
    validationPremium() {
      let valid = true;
      if (this.form.name == "") {
        this.error.name = "Nama tidak boleh kosong";
        valid = false;
      } else {
        this.error.name = "";
      }
      if (this.form.email == "") {
        this.error.email = "Email tidak boleh kosong";
        valid = false;
      } else {
        this.error.email = "";
      }
      if (this.form.phone == "") {
        this.error.phone = "No. HP tidak boleh kosong";
        valid = false;
      } else {
        this.error.phone = "";
      }

      return valid;
    },
    async formOnSubmit() {
      if (this.is_email_valid == false) {
        Swal.fire("Gagal", "Email tidak valid", "error");
        return;
      }

      if (this.validation() == false) {
        Swal.fire("Gagal", "Harap periksa kembali form", "error");
        return;
      }
      if (this.form.payment_bank == "") {
        Swal.fire("Error", "Pilih metode pembayaran terlebih dahulu", "error");
        return;
      }

      //   this.form.registrant_id = getRegistrant().id;
      this.form.course_id = this.program.id;
      if (this.discount) {
        this.form.discount_id = this.discount.id;
      }

      let route = "api/register-class";
      if (this.form.is_installment == 1) {
        route = "api/register-installment";
      }
      if (this.form.is_installment == 1) {
        this.form.installment_list = JSON.stringify(this.installments);
      }

      let formData = new FormData();
      for (const [key, value] of Object.entries(this.form)) {
        formData.append(key, value);
      }
      // Make Request
      let response = await module.submit(formData, route);
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        // Swal.fire(response.success.title, response.success.message, "success");
        if (this.discount) {
          response.success.billing.original.discount_code =
            this.form.promo_code;
        }
        setBilling(JSON.stringify(response.success.billing.original));
        setRegistrant(JSON.stringify(response.success.registrant.original));
        this.$router.push(this.routePushGeneral);
      }
    },
    async premiumRegister() {
      if (this.is_email_valid == false) {
        Swal.fire("Gagal", "Email tidak valid", "error");
        return;
      }
      if (this.validationPremium() == false) {
        Swal.fire("Gagal", "Harap periksa kembali form", "error");
        return;
      }

      let formData = new FormData();
      this.form.is_pay_later = 1;
      for (const [key, value] of Object.entries(this.form)) {
        formData.append(key, value);
      }

      // Make Request
      let response = await module.submit(formData, "api/register-premium");
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        // Swal.fire(response.success.title, response.success.message, "success");
        this.form.course_type_id = "";
        this.form.name = "";
        this.form.email = "";
        this.form.phone = "";
        this.form.agency_name = "";
        this.form.course_price_id = "";
        this.form.attachment = "";
        this.uploadedImageUrl = "";

        this.is_program_selected = false;
        Swal.fire(
          response.success.title,
          `Kami sudah mengirimkan detail informasi pendaftaran ke Email dan
  WhatsApp Anda. Silakan cek kotak masuk atau spam Anda, dan
  jangan ragu untuk menghubungi kami jika ada pertanyaan lebih
  lanjut.`,
          "success"
        ).then(() => {
          // window.location.href = "https://digiskillhub.id";
        });

        this.$root.$emit("premiumRegisterSuccess");
        // this.$router.push("/class/register");
        // this.goBack();
      }
    },
  },
  mounted() {
    this.getPaymentMethod();
    this.getPaymentOption();

    if (
      this.$route.query.hasOwnProperty("course") &&
      this.$route.query.course != ""
    ) {
      this.is_program_selected = true;
      this.form.course_key_name = this.$route.query.course.replace(/\s+/g, "");
      this.is_card_program_show = false;
    }

    if (this.current_user) {
      this.form.name = this.current_user.name;
      this.form.phone = this.current_user.phone;
      this.form.email = this.current_user.email;

      this.is_biodata_form_show = false;
    }
  },
  watch: {
    current_user: {
      handler(newVal) {
        if (newVal) {
          this.form.name = newVal.name;
          this.form.phone = newVal.phone;
          this.form.email = newVal.email;

          this.is_biodata_form_show = false;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.img-wrapper-course {
  height: 300px;
  width: 300px;
}

.img-wrapper-course img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.photo-wrapper {
  height: 150px;
  width: 300px;
}

.photo-wrapper img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
</style>

<style>
/* .my-treeselect .vue-treeselect__input {
  border: none !important;
} */
.my-treeselect .vue-treeselect__control {
  height: 45px;
}
</style>

<style scoped>
.svg-wrapper {
  height: 20px;
  width: 20px;
  object-fit: contain;
}
.svg-wrapper svg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.img-wrapper {
  width: 120px;
  height: 120px;
}
.img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.payment-tile {
  background-color: white;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #dee2e6;
}

.payment-tile:hover {
  border-color: #0d6efd;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
  transform: translateY(-3px);
}

.payment-tile.selected {
  border: 2px solid #0d6efd;
  background-color: #f0f9ff;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.1);
}

.checkmark-icon {
  background-color: #fff;
  border-radius: 50%;
}

.text-summary {
  font-size: 16px;
}

.text-summary-detail {
  font-size: 16px;
}
</style>

<style scoped>
.register-back-btn {
  background: #fff !important;
  /* border: 3px solid #f40396 !important; */
  border-color: #f40396 !important;
  color: #f40396 !important;
  border-radius: 18px;
}

.card-wrapper {
  min-height: 500px;
}

.title {
  font-size: 18px;
  font-weight: bold;
}

.desc {
  font-size: 16px;
  margin-bottom: 1rem;
}

.background-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #dcdcdc;
  border-radius: 20px;
  z-index: 0;
  transform: none;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.card-wrapper:hover .custom-card,
.custom-card.active {
  transform: rotateZ(-3deg) translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  z-index: 2;
  /* background: #dcdcdc; */
}

.custom-card {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  z-index: 1;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.custom-card.active {
  transform: rotateZ(-3deg) translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  z-index: 2;
}

.card-img {
  height: 50%;
  background-size: cover;
  background-position: center;
  transition: transform 0.3s ease;
}

.card-bottom {
  padding: 1.2rem;
}
</style>

<style scoped>
.course-card {
  border-radius: 16px;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.course-card h5 {
  font-size: 1.1rem;
}

.course-card i {
  display: block;
}
</style>
